import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { FlameWatermark } from './ui/FlameWatermark';
export function Hero() {
  return <section className="relative bg-cream pt-24 pb-16 md:pt-32 md:pb-20 overflow-hidden" data-id="element-199">
      <FlameWatermark className="top-10 left-10 w-64 h-64 !text-orange" data-id="element-200" />

      <div className="max-w-[1200px] mx-auto px-6 md:px-8 relative z-10" data-id="element-201">
        <div className="flex flex-col lg:grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-202">
          {/* Text Column */}
          <div className="text-center lg:text-center flex flex-col items-center" data-id="element-203">
            {/* Eyebrow + Title - always first */}
            <FadeIn data-id="element-204">
              <div className="inline-block mb-6" data-id="element-205">
                <span className="font-poppins font-semibold uppercase tracking-[0.15em] text-[13px] text-plum bg-plum/10 px-4 py-2 rounded-full inline-block text-center" data-id="element-206">
                  COACHING RELAȚIONAL
                  <br className="md:hidden" data-id="element-207" /> & ANALIZĂ COMPORTAMENTALĂ
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-208">
              <h1 className="text-[36px] md:text-[52px] leading-[1.1] font-semibold mb-6" data-id="element-209">
                Dezamorsează-ți butoanele reactive și creează armonie cu cei
                dragi
              </h1>
            </FadeIn>

            {/* Photo - shown ONLY on mobile, between title and subtitle */}
            <FadeIn delay={0.2} className="relative w-full lg:hidden mb-8" data-id="element-210">
              <div className="relative w-full aspect-[4/5] max-w-[360px] mx-auto" data-id="element-211">
                <div className="absolute -bottom-4 -left-4 w-full h-full border-2 border-plum/60 rounded-[24px] z-0" data-id="element-212"></div>
                <div className="relative z-10 w-full h-full rounded-[24px] overflow-hidden shadow-card-hover border border-plum-border" data-id="element-213">
                  <img src="https://cdn.magicpatterns.com/uploads/ppWtVPupFFFXGyrfvdjss7/Stela-business.jpg" alt="Stela Lucuța - Coach și Consultant Comportamental DISC" className="w-full h-full object-cover object-top" data-id="element-214" />
                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-plum/20 to-transparent" data-id="element-215"></div>
                </div>
                <svg className="absolute -bottom-4 -right-6 w-14 h-14 z-20 text-orange opacity-80" viewBox="0 0 100 100" fill="currentColor" data-id="element-216">
                  <path d="M50 0C50 0 20 30 20 60C20 76.5685 33.4315 90 50 90C66.5685 90 80 76.5685 80 60C80 30 50 0 50 0ZM50 75C41.7157 75 35 68.2843 35 60C35 45 50 25 50 25C50 25 65 45 65 60C65 68.2843 58.2843 75 50 75Z" data-id="element-217" />
                </svg>
              </div>
            </FadeIn>

            {/* Subtitle */}
            <FadeIn delay={0.2} data-id="element-218">
              <p className="text-[17px] md:text-[19px] leading-[1.65] text-plum-light mb-10 max-w-[540px] mx-auto" data-id="element-219">
                Un proces ghidat pentru persoane perfecționiste, copleșite de
                grijă și control, care vor să răspundă calm și ferm, nu să
                reacționeze impulsiv. Folosim analiza comportamentală DISC și
                instrumentele Metodei A.E.R.
              </p>
            </FadeIn>

            {/* Button + small text */}
            <FadeIn delay={0.3} data-id="element-220">
              <div className="flex flex-col items-center gap-4" data-id="element-221">
                <a href="https://wa.me/40744377234" target="_top" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 rounded-lg font-poppins font-semibold text-[16px] transition-all duration-200 hover:scale-[1.02] cursor-pointer no-underline bg-orange text-white hover:bg-orange-hover hover:shadow-btn-orange" data-id="element-222">
                  Vezi cum poți lucra cu mine
                </a>
                <p className="text-[14px] text-warmgray leading-[1.5]" data-id="element-223">
                  Patru programe, de la ateliere lunare până la Coaching &
                  Mentorare 1 la 1. Alegi ritmul tău.
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Right Column: Photo with Decorative Elements - DESKTOP ONLY */}
          <FadeIn delay={0.4} className="relative hidden lg:block" data-id="element-224">
            <div className="relative w-full aspect-[4/5] max-w-[480px] mx-auto lg:ml-auto" data-id="element-225">
              {/* Decorative dots pattern - top right */}
              <svg className="absolute -top-8 -right-8 w-32 h-32 z-0 opacity-30" viewBox="0 0 100 100" data-id="element-226">
                {Array.from({
                length: 36
              }).map((_, i) => <circle key={i} cx={i % 6 * 18 + 10} cy={Math.floor(i / 6) * 18 + 10} r="2.5" fill="#3D1635" data-id="element-227" />)}
              </svg>

              {/* Gradient ring behind photo */}
              <div className="absolute -inset-6 rounded-[32px] bg-signature-gradient opacity-[0.12] blur-sm z-0" data-id="element-228"></div>

              {/* Plum offset frame */}
              <div className="absolute -bottom-5 -left-5 w-full h-full border-2 border-plum/60 rounded-[24px] z-0" data-id="element-229"></div>

              {/* Plum accent line - top left */}
              <div className="absolute -top-3 -left-3 w-20 h-20 border-t-2 border-l-2 border-plum/30 rounded-tl-[16px] z-0" data-id="element-230"></div>

              {/* Main Image */}
              <div className="relative z-10 w-full h-full rounded-[24px] overflow-hidden shadow-card-hover border border-plum-border" data-id="element-231">
                <img src="https://cdn.magicpatterns.com/uploads/ppWtVPupFFFXGyrfvdjss7/Stela-business.jpg" alt="Stela Lucuța - Coach și Consultant Comportamental DISC" className="w-full h-full object-cover object-top" data-id="element-232" />
                {/* Subtle gradient overlay at bottom */}
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-plum/20 to-transparent" data-id="element-233"></div>
              </div>

              {/* Small flame accent - bottom right */}
              <svg className="absolute -bottom-4 -right-6 w-14 h-14 z-20 text-orange opacity-80" viewBox="0 0 100 100" fill="currentColor" data-id="element-234">
                <path d="M50 0C50 0 20 30 20 60C20 76.5685 33.4315 90 50 90C66.5685 90 80 76.5685 80 60C80 30 50 0 50 0ZM50 75C41.7157 75 35 68.2843 35 60C35 45 50 25 50 25C50 25 65 45 65 60C65 68.2843 58.2843 75 50 75Z" data-id="element-235" />
              </svg>

              {/* Abstract amber blob */}
              <div className="absolute -top-12 -right-12 w-72 h-72 bg-amber/15 rounded-full blur-3xl z-0" data-id="element-236"></div>

              {/* Small violet accent blob */}
              <div className="absolute -bottom-10 left-10 w-40 h-40 bg-violet/10 rounded-full blur-2xl z-0" data-id="element-237"></div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}